export const randomSeed = () => Math.floor(Math.random() * 4294967296);
